module.exports = __webpack_public_path__ + "static/img/tupian.d61ff7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tupian.png
// module id = pWgr
// module chunks = 1